import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Mc_papers = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    >
                        <h1 className="title">MC 論文</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">論文徵稿主題</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>5G, 6G, LTE, LTE-Advanced, WLAN, WPAN</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>AI Technologies and Applications</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Cloud, Fog, and Edge Computing</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Cyber Security and Privacy</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Device to Device (D2D) Communication</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Energy-Efficient Software and Hardware Design</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Fault Tolerance in Mobile Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Internet of Thing (IoT) Technology</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobile and Wireless Network Architectures</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobile and Wireless Network Protocol Design</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobility and Location Management</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Modeling and Performance Analysis of Wireless Systems</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Network Function Virtualization</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Satellite Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Software-Defined Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Spectrum Management</li>
                        </ul>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Mc_papers;